import React, { useMemo } from "react";
import { Typography, Grid, Divider, Box } from "@mui/material";

const Row = ({ label, item, value, bold, color }) => (
    <Grid container alignItems="center" sx={{ mb: 0.8 }}>
        <Grid item xs={5}>
            <Typography variant="body2" fontWeight={bold ? 600 : 400}>
                {label}
            </Typography>
        </Grid>
        <Grid item xs={4}>
            <Typography variant="body2" fontWeight={bold ? 600 : 400}>
                {item || ""}
            </Typography>
        </Grid>
        <Grid item xs={3} textAlign="right">
            <Typography
                variant="body2"
                fontWeight={bold ? 600 : 400}
                color={color || "text.primary"}
            >
                {value}
            </Typography>
        </Grid>
    </Grid>
);

export default function PaymentInfo({ orderInfo = {} }) {
    const price = orderInfo?.priceInfo || {};

    const {
        subTotal = 0,
        platformFee = 0,
        urgentCharges = 0,
        onsiteVisitAmount = 0,
        additonalCharges = 0,
        deliveryFee = 0,
        couponAmount = 0,
        taxPerc = 0,
        taxAmount = 0,
        tipAmount = 0,
        payableAmount = 0,
    } = price;

    const itemCount = orderInfo?.orderItems?.length || 0;

    const taxableBase = useMemo(() => {
        return (
            subTotal +
            platformFee +
            onsiteVisitAmount +
            urgentCharges +
            additonalCharges +
            deliveryFee -
            couponAmount
        );
    }, [
        subTotal,
        platformFee,
        onsiteVisitAmount,
        urgentCharges,
        additonalCharges,
        deliveryFee,
        couponAmount,
    ]);

    return (
        <Box sx={{ border: 1, borderColor: "divider", borderRadius: 2, p: 2 }}>
            
            {/* Header */}
            <Row label="Component" item="Item" value="Amount" bold />

            <Divider sx={{ my: 1 }} />

            {/* Charges */}
            <Row label="Subtotal" item={`${itemCount} Item`} value={`$${subTotal}`} />
            <Row label="Platform Fee" value={`$${platformFee}`} />

            {urgentCharges > 0 && (
                <Row label="Express Charges" value={`$${urgentCharges.toFixed(2)}`} />
            )}

            {onsiteVisitAmount > 0 && (
                <Row label="Visiting Charges" value={`$${onsiteVisitAmount.toFixed(2)}`} />
            )}

            {additonalCharges > 0 && (
                <Row label="Additional Charges" value={`$${additonalCharges.toFixed(2)}`} />
            )}

            <Row label="Delivery Fee" value={`$${deliveryFee}`} />

            {couponAmount > 0 && (
                <Row
                    label="Discount"
                    item={orderInfo?.coupon?.code || "---"}
                    value={`-$${couponAmount.toFixed(2)}`}
                    color="success.main"
                />
            )}

            {/* Taxable */}
            <Row
                label="Taxable Base"
                value={`$${taxableBase.toFixed(2)}`}
                bold
            />

            <Row label={`Tax (${taxPerc}%)`} value={`$${taxAmount}`} />

            {tipAmount > 0 && <Row label="Tip" value={`$${tipAmount}`} />}

            <Divider sx={{ my: 1 }} />

            {/* Total */}
            <Row
                label="Total"
                item={`${itemCount} Item`}
                value={`$${Number(payableAmount).toFixed(2)}`}
                bold
            />
        </Box>
    );
}